// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Loading-bg[data-v-01bf7c36]{position:fixed;left:0;top:0;width:100%;height:100vh;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);z-index:70010;display:flex;align-items:center;justify-content:center}.Loading-bg div[data-v-01bf7c36]{text-align:center;font-weight:700;text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
